import {CreditGrantTypeEnum} from '../../model/credit/credit-grant-type.enum';
import axios from '../axios';

export namespace CreditGrantController {
  export type CreateGrantReq = {
    type: CreditGrantTypeEnum
    hours: number
    validUntil?: string | null
    comment?: string | null
  }

  export const createCreditGrant = async (organizationId: string, request: CreateGrantReq) =>
    (await axios.post(`/internal/credit/accounts/${organizationId}/grants`, request))
}
